import ProductBrowse from '../components/products/ProductBrowse';

const ProductsPage = () => {
  return <ProductBrowse />;
};

export default ProductsPage;